import type { ReactNode } from "react";

export interface PageHeaderProps {
  /**
   * The content of the header, typically PageTitle and action buttons
   */
  children: ReactNode;
  /**
   * Optional className for the header
   */
  className?: string;
}

export function PageHeader({
  children,
  className = "",
}: Readonly<PageHeaderProps>) {
  return (
    <div
      className={`flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 ${className}`}
    >
      {children}
    </div>
  );
}
